export enum EnumOperationState {
  Borrador = 1,
  Enviada,
  Rechazado,
  PendienteRenvio,
  Anulada,
  DP,
  FP,
  FD,
  EnviadoKO
}
